import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import StaticFunctions from "../../utils/StaticFunctions";
import TableContainer from "../../utils/TableContainer";
import SearchField from "../../utils/SearchField";
import Timeformat from "../../utils/Timeformat";
import LoadingSplash from "../../globalComponents/LoadingSplash";

class OperatorTokenOverviewContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        currentCompany: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            currentCompany: this.props.baseData.companies.currentCompany,
            currentOperatorsToken: null,
            filteredOperatorsToken: null,
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);

        this.requestOperatorTokenOverview = this.requestOperatorTokenOverview.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.getTableRows = this.getTableRows.bind(this);

    }

    componentWillMount() {

        this.requestOperatorTokenOverview();

    }

    /*componentWillReceiveProps(nextProps) {

        this.setState({
            currentCompany: nextProps.baseData.companies.currentCompany
        }, this.requestOperatorTokenOverview);

    }*/

    requestOperatorTokenOverview() {

        if (!this.props.baseData.companies.currentCompany || !this.state.currentCompany) return null;

        const params = {
            action: 'getCompanyOperatorTokenOverview',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.state.currentCompany.id
        };

        const callback = function(res) {
            if (res) {
                const data = this.getTableRows(res);

                this.setState({
                    currentOperatorsToken: data,
                    filteredOperatorsToken: data,
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    onSearch(name, value) {

        const tableData = this.state.currentOperatorsToken;
        const filteredData = StaticFunctions.findSubstringInObjArray(tableData, value, ['id_token', 'token_name', 'operator_name', 'date_start', 'date_end', 'date_created']);

        this.setState({
            filteredOperatorsToken: filteredData
        });

    }

    onSearchSave(name, value) {

        if (!value) return null;

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const format = this.timeFormats.datetime;
        const searchFields = ['id_operator', 'operator_name', 'id_token'];
        const companyName = this.props.baseData.companies.currentCompany.name;
        const rows = this.state.currentOperatorsToken || [];
        const filteredRows = [];

        if (rows) {
            rows.some(
                (row) => {
                    let addToResult = false;
                    let last_seen = (row.last_seen) ? Timeformat.fromUnix(row.last_seen).getFormatedDate(format, timezone) : '';
                    let date_start = (row.date_start) ? Timeformat.fromUnix(row.date_start).getFormatedDate(format, timezone) : '';
                    let date_end = (row.date_end) ? Timeformat.fromUnix(row.date_end).getFormatedDate(format, timezone) : '';
                    let last_modified = (row.last_modified) ? Timeformat.fromUnix(row.last_modified).getFormatedDate(format, timezone) : '';
                    let date_created = (row.date_created) ? Timeformat.fromUnix(row.date_created).getFormatedDate(format, timezone) : '';
                    let date_deleted = (row.date_deleted) ? Timeformat.fromUnix(row.date_deleted).getFormatedDate(format, timezone) : '';

                    if (companyName && StaticFunctions.substringExists(companyName, value)) {
                        addToResult = true;
                    } else if (last_seen && StaticFunctions.substringExists(last_seen, value)) {
                        addToResult = true;
                    } else if (date_start && StaticFunctions.substringExists(date_start, value)) {
                        addToResult = true;
                    } else if (date_end && StaticFunctions.substringExists(date_end, value)) {
                        addToResult = true;
                    } else if (last_modified && StaticFunctions.substringExists(last_modified, value)) {
                        addToResult = true;
                    } else if (date_created && StaticFunctions.substringExists(date_created, value)) {
                        addToResult = true;
                    } else if (date_deleted && StaticFunctions.substringExists(date_deleted, value)) {
                        addToResult = true;
                    } else {
                        searchFields.forEach(
                            (searchField) => {
                                if (row[searchField] && StaticFunctions.substringExists(row[searchField], value)) addToResult = true;
                            }
                        );
                    }

                    if (addToResult) filteredRows.push(row);
                }
            );
        }

        this.setState({
            filteredOperatorsToken: filteredRows
        });

    }

    onCancel() {

        this.setState({
            filteredOperatorsToken: this.state.currentOperatorsToken,
        });

    }

    operatorTokenDetails(operatorToken) {

        this.changeView('edit', operatorToken);

    }

    changeView(view, operator = null) {

        if (this.props.changeView) this.props.changeView(view, operator);

    }

    getOperatorColumns() {

        return [
            {
                key: 'id_token',
                nameKey: 'token',
                sortType: 'string',
            },
            {
                key: 'token_name',
                nameKey: 'tokenName',
                sortType: 'string',
            },
            {
                key: 'operator_name',
                nameKey: 'operator',
                sortType: 'string',
            },
            {
                key: 'date_start',
                nameKey: 'tokenValidFrom',
                sortType: 'datetime',
            },
            {
                key: 'date_end',
                nameKey: 'tokenValidTill',
                sortType: 'datetime',
            },
            {
                key: 'date_created',
                nameKey: 'tokenRegisterOn',
                sortType: 'datetime',
            },
            {
                key: 'options',
                nameKey: 'options',
            },
        ];

    }

    getOperatorRows() {

        return this.state.filteredOperatorsToken;

    }

    getTableRows(data) {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const format = this.timeFormats.datetime;
        const rows = [];

        data = data || [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];
            let dateStart = (rowTemp.date_start) ? Timeformat.fromUnix(rowTemp.date_start).getFormatedDate(format, timezone) : '-';
            let dateEnd = (rowTemp.date_end) ? Timeformat.fromUnix(rowTemp.date_end).getFormatedDate(format, timezone) : '-';
            let dateCreated = (rowTemp.date_created) ? Timeformat.fromUnix(rowTemp.date_created).getFormatedDate(format, timezone) : '-';

            rows.push({
                id: rowTemp.id_token,
                id_token: rowTemp.id_token,
                token_name: rowTemp.token_name,
                operator_name: rowTemp.operator_name,
                date_start: dateStart,
                date_end: dateEnd,
                date_created: dateCreated,
                options: <div className="tableOptions">
                    <a className="optionEdit" onClick={() => this.operatorTokenDetails(rowTemp)} title={this.translate('edit')}>&nbsp;</a>
                </div>,
            });
        }

        return rows;

    }

    render() {

        if (!this.state.filteredOperatorsToken) return <LoadingSplash color={'dark'}/>;

        const dataCount = (this.state.filteredOperatorsToken) ? this.state.filteredOperatorsToken.length : 0;
        const countText = this.translate('token');
        const operatorColumns = this.getOperatorColumns();
        const operatorRows = this.getOperatorRows();

        return (
            <div>
                <div className="ma-bo-20 clearfix">
                    <div className="clearfix">
                        <nav>
                            <h1>{this.translate('selectOperatorToken')}</h1>

                            <SearchField
                                baseData={this.props.baseData}
                                name="searchOperatorTokenOverview"
                                placeholder={this.translate('searching')}
                                styles={{padding: 0}}
                                onSearch={this.onSearch}
                                onCancel={this.onCancel}
                            />
                        </nav>
                    </div>

                    <div className="clearfix">
                        <div className="fll">
                            <p>{dataCount} {countText} {this.translate('found')}. {this.translate('noTokenFoundNote2')}</p>
                        </div>
                    </div>

                    <div className="clearfix">
                        <TableContainer
                            baseData={this.props.baseData}
                            columns={operatorColumns}
                            rows={operatorRows}
                            fillGaps="-"
                        />
                    </div>
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('admin')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default OperatorTokenOverviewContainer;
